

export default function PackExtPlus() {
    // state

    // comportement

    // affichage
    return (
        <div className="tab-pane fade active show" id="features-tab-1">
            <div className="row">
                <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
                    <h3>KIT_YCONNEKT-EXT+</h3>
                    <p className="fst-italic">
                    Ce kit offre une couverture extrêmement large, jusqu'à 3 kilomètres. Il est parfait pour les zones rurales ou semi-rurales, ou pour couvrir de grandes zones urbaines comme des quartiers commerciaux importants ou des lieux à forte densité de population.
                    </p>
                    <ul>
                        <li><i className="bi bi-check2-all"></i> <span>Couverture : 3 km.</span></li>
                        <li><i className="bi bi-check2-all"></i> <span>Nombre de client : 600 users max.</span></li>
                        <li><i className="bi bi-check2-all"></i> <span>Routeur-yconnekt.</span></li>
                        <li><i className="bi bi-check2-all"></i> <span>05 Antenne wifi.</span></li>
                    </ul>
                    <div className="pricing">
                        <div className="pricing-card">
                            <div className="price">
                                {/* <span className="currency">XAF</span> */}
                                <span className="amount">2.000.000</span>
                                <span className="period"> FCFA</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 order-1 order-lg-2 text-center">
                    <img src="/assets/imgs/pack4.jpg" alt="" className="img-fluid" />
                </div>
            </div>
        </div>
    );
}